export default __webpack_public_path__ + "static/media/Group 30883.93d7adce.svg";